module.exports = __webpack_public_path__ + "static/media/ISCI_SNSE1.2f7caf42.jpg";